import WebApiService from '../services/WebApiService';

export default class ContestsService extends WebApiService {

    constructor() {
        super();

        this.post = super.post.bind(this);
        this.get = super.get.bind(this);
    }

    //// General

    getMasterKpis(successCallback, errorCallback) {
        this.get('/api/Contests/MasterKpis', successCallback, errorCallback)
    }

    //// All Contests

    getMyContests(payload, successCallback, errorCallback) {
        payload.userId = zzDataCache.account.userId;
        this.post('/api/Contests/MyRelevantContests', payload, successCallback, errorCallback);
    }

    archiveContest(contestId, successCallback, errorCallback) {
        this.get('/api/Contests/Archive/' + contestId, successCallback, errorCallback);
    }

    //// Ranked Contest

    createRankedContest(payload, successCallback, errorCallback) {
        payload.userId = zzDataCache.account.userId;
        this.post('/api/Contests/CreateRankedContest', payload, successCallback, errorCallback);
    }

    editRankedContest(payload, successCallback, errorCallback) {
        this.post('/api/Contests/EditRankedContest/' + zzDataCache.account.userId, payload, successCallback, errorCallback);
    }

    deleteRankedContest(payload, successCallback, errorCallback) {
        this.post('/api/Contests/DeleteRankedContest', payload, successCallback, errorCallback);
    }

    getRankedContestList(pullData, clientAccountId, successCallback, errorCallback) {
        this.get('/api/Contests/RankedContestList/' + pullData + "/" + clientAccountId, successCallback, errorCallback);
    }

    getRankedContest(pullData, rankedContestId, successCallback, errorCallback) {
        this.get('/api/Contests/RankedContest/' + pullData + "/" + rankedContestId, successCallback, errorCallback);
    }

    //// Raffle Contest

    createRaffleContest(payload, successCallback, errorCallback) {
        payload.userId = zzDataCache.account.userId;
        this.post('/api/Contests/CreateRaffleContest', payload, successCallback, errorCallback);
    }

    editRaffleContest(payload, successCallback, errorCallback) {
        this.post('/api/Contests/EditRaffleContest/' + zzDataCache.account.userId, payload, successCallback, errorCallback);
    }

    deleteRaffleContest(payload, successCallback, errorCallback) {
        this.post('/api/Contests/DeleteRaffleContest', payload, successCallback, errorCallback);
    }

    getRaffleContestList(pullData, clientAccountId, successCallback, errorCallback) {
        this.get('/api/Contests/RaffleContestList/' + pullData + "/" + clientAccountId, successCallback, errorCallback);
    }

    getRaffleContest(pullData, raffleContestId, successCallback, errorCallback) {
        this.get('/api/Contests/RaffleContest/' + pullData + "/" + raffleContestId, successCallback, errorCallback);
    }

    setRaffleWinner(winner, raffleContestId, successCallback, errorCallback) {
        this.get('/api/Contests/SetRaffleWinner/' + winner + "/" + raffleContestId, successCallback, errorCallback);
    }
}